import React from 'react';

const ErrorMessageTemplate = ({ message }) => {
  if(!message) return null;
  return (
    <div className="errorMessage">
      <i className="fas fa-exclamation-circle" title={message} />
      {message}
    </div>
  );
};

export default React.memo(ErrorMessageTemplate);
